export const Urls = {
   // ads
   ads: '/ads',
   store_ads: '/ads/new',
   exportAds: '/ads/export',

   // announcements
   announcements: '/announcements',
   store_announcement: '/announcements/new',
   exportAnnouncements: '/announcements/export',

   // switchprovider
   providers: '/buyload/providers',


   // buyload
   buyload: '/buyload/items',
   store_buyload: '/buyload/items/new',
   exportBuyload: '/buyload/items/exportAll',
   gamingPinsBuyload: '/buyload/items/saveGamingPin',

   // categories
   category: '/gaming/categories',

   cashIn: '/cardPaymentProviders/all',
   store_provider: '/cardPaymentProviders/new',
   updateCashIn: '/cardPaymentProviders',
   switch: '/cardPaymentProviders/switch',

   // paybills
   billers: '/billers',
   store_billers: '/billers/new',
   fields_billers: '/billers/fieldNames',
   exportPaybills: '/billers/excel',

   // stores
   items: '/stores/items',
   store_items: '/stores/items/new',
   exportItems: '/stores/item/excel',

   // users
   users: '/users',
   store_users: '/users/new',
   login: '/users/login',
   logout: '/users/logout',

   // user accounts
   userAccount: '/accounts',
   exportAccounts: '/accounts/export',
   exportuserAccount: '/accounts/excel',
   tiers: '/tiers',

   // kyc registration
   kycRegistrations: '/kyc/registrations',
   exportKycRegistrations: '/kyc/registrations/excel',

   // kyc logs
   kycLogs: '/kyc/logs',
   exportKycLogs: '/kyc/logs/excel',

   // pushNotif
   pushNotif: '/push_notifications',
   store_pushNotif: '/push_notifications/new',
   exportPushNotif: '/push_notifications/excel',

   // all transactions
   transactionsAll: '/transactions/all',
   exportTransactionsAll: '/transactions/all/excel',

   // buyload
   transactionsBuyload: '/transactions/buyload',
   exportTransactionsBuyload: '/transactions/buyload/excel',

   // cashin
   transactionsCashin: '/transactions/cashin',
   exportTransactionsCashin: '/transactions/cashin/excel',

   // paybills
   transactionsPaybills: '/transactions/paybills',
   exportTransactionsPaybills: '/transactions/paybills/excel',

   // transfers
   transactionsTransfers: '/transactions/transfer',
   exportTransactionsTransfers: '/transactions/transfer/excel',

   // purchases
   transactionsPurchases: '/transactions/purchases',
   exportTransactionsPurchases: '/transactions/purchases/excel',

   // rewards
   transactionsRewards: '/transactions/rewards',
   exportTransactionsRewards: '/transactions/rewards/excel',

   // overview
   transactionsOverview: '/transactions/overview',
   exportTransactionsOverview: '/transactions/overview/excel',

   // cashin
   cashinDeposits: '/cashin/deposits/',
   exportCashinDeposits: '/cashin/deposits/excel',

   // cashout
   cashoutDeposits: '/cashout/deposits',
   exportCashoutDeposits: '/cashout/deposits/excel',

   // summary
   summary: '/reports/summary',
   exportSummary: '/reports/summary/excel',

   // dailySales
   dailySales: '/reports/dailySales',
   exportDailySales: '/reports/dailySales/excel',

   // topUsers
   topUsers: '/reports/topUsers',
   exportTopUsers: '/reports/topUsers/excel',

      // referralCommissions
   referralCommissions: '/reports/referralCommissions',
   referralCommissionsVerify: '/reports/referralCommissions/verify',
   exportReferralCommission: '/reports/referralCommissions/excel',

      // admin portal user logs
   portalUserLogs: '/portal/users/logs',

      // changePassword
   changePassword: '/user/accounts/password/update',

   // maintenance
   maintenance: '/maintenance',

   // sendForgot
   sendForgotPasswordEmail: '/users/sendForgotPasswordEmail',

   // reset
   reset: '/users/resetPassword',

   // redeem percentage
   redeem: '/redeem',
   exportTransactionsRedeem: '/redeem/excel',

   // profanity filter
   profanity: '/profanity',

   // auto disable logs
   logs: '/logs',
   exportAutoDisableLogs: '/logs/excel',

   // disbursment
   disbursement: '/disbursement',


   // buyload rebate
   buyloadRebate: '/buyload/rebates',

   // referrals
   referrals: '/referrals',
   exportReferralAccounts: '/referrals/export',
   exportReferredAccounts: '/referrals/exportByReferrerNumber',

   // Third Party Logs
   buyloadlogs: '/thirdpartylogs/buyload',
   exportBuyloadLogs: '/thirdpartylogs/buyload/excel',

   paybillslogs: '/thirdpartylogs/paybills',
   exportPayBillsLogs: '/thirdpartylogs/paybills/excel',

   cashinlogs:  '/thirdpartylogs/cashin',
   exportCashInLogs: '/thirdpartylogs/cashin/excel',

   storeslogs: '/thirdpartylogs/stores',
   exportStoreLogs: '/thirdpartylogs/stores/excel',

   redeemlogs: '/thirdpartylogs/redeem',
   exportRedeemLogs: '/thirdpartylogs/redeem/excel',


   // features
   features: '/features',


   // distributors rdpd
   rdpd: '/distributors',

   // version controls
   versionControls: '/versionControl'
}
